import { render, staticRenderFns } from "./NomenclatureWidgetComponent.vue?vue&type=template&id=006d5899&scoped=true"
import script from "./NomenclatureWidgetComponent.vue?vue&type=script&lang=js"
export * from "./NomenclatureWidgetComponent.vue?vue&type=script&lang=js"
import style0 from "./NomenclatureWidgetComponent.vue?vue&type=style&index=0&id=006d5899&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006d5899",
  null
  
)

export default component.exports